// The channel's screen icons (S1, picked Oct 26): drawings in brand/icons.svg, which the build serves as
// rhl/icons.svg. The file is put into the page once, hidden, so <use href="#i-crab"> works with its gradients; the
// bumper's "up next" card and Coming Up use them.
const SPRITE = 'rhl/icons.svg';

const ready = fetch(SPRITE)
	.then((r) => (r.ok ? r.text() : ''))
	.then((text) => {
		if (!text) return;
		const holder = document.createElement('div');
		holder.setAttribute('aria-hidden', 'true');
		holder.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden';
		holder.innerHTML = text;
		// inside the channel's frame: kiosk mode hides everything else in the body, and Chrome stops drawing a gradient
		// whose definition is display:none, so outside it the icons lost every gradient fill on the TV (Oct 26)
		(document.querySelector('#divTwc') ?? document.body).append(holder);
	})
	.catch(() => {});

// a screen's name (as the loop names it) to its icon
const BY_SCREEN = [
	[/crab/i, 'crab-c'],
	[/tide|bay &/i, 'i-tide'],
	[/fog/i, 'i-fog'],
	[/getting around|transit/i, 'i-cable'],
	[/market/i, 'i-market'],
	[/news|headline/i, 'i-news'],
	[/views/i, 'i-cam'],
	[/around town/i, 'i-bridge'],
	[/air/i, 'i-air'],
	[/quake/i, 'i-quake'],
	[/sunset|sunrise/i, 'i-sunset'],
];
// a Coming Up countdown to its icon; events without one get none
const BY_COUNTDOWN = [
	[/crab|dungeness/i, 'crab-c'],
	[/king tide/i, 'i-tide'],
	[/halloween/i, 'c-pumpkin'],
	[/clocks|daylight saving/i, 'c-clock'],
	[/thanksgiving/i, 'c-turkey'],
	[/meteor|geminid|perseid/i, 'c-meteor'],
	[/christmas/i, 'c-tree'],
	[/lunar new year/i, 'c-lantern'],
	[/new year|fourth of july|independence/i, 'c-firework'],
	[/giants|opening day|home opener/i, 'c-baseball'],
	[/breakers|marathon|run\b/i, 'c-shoe'],
	[/pride/i, 'c-rainbow'],
	[/eclipse|moon/i, 'c-moon'],
	[/hardly strictly|bluegrass/i, 'c-banjo'],
	[/fleet week|air show|blue angels/i, 'c-jet'],
	[/solstice|equinox/i, 'i-sunset'],
	[/49ers|warriors|bridge/i, 'i-bridge'],
];
// any other countdown still gets a picture
const COUNTDOWN_FALLBACK = 'c-calendar';

const pick = (table, text) => table.find(([re]) => re.test(text ?? ''))?.[1] ?? null;
const svg = (id) => (id ? `<svg class="rhl-icon" viewBox="0 0 100 80" aria-hidden="true"><use href="#${id}"/></svg>` : '');

const screenIcon = (name) => svg(pick(BY_SCREEN, String(name ?? '').replace(/&amp;/g, '&')));
const countdownIcon = (name) => svg(pick(BY_COUNTDOWN, name) ?? COUNTDOWN_FALLBACK);

export { ready, screenIcon, countdownIcon };
